import intl from 'react-intl-universal';
import { changeReceiveStatus } from '@/api/login';
// import {
//     UserOutlined,
//     CheckCircleFilled,
//     MinusCircleFilled,
// } from '@ant-design/icons';
import { message } from 'antd';
import { useModel } from 'umi';
import styles from './index.less';

const ReceiveStatus: React.FC = () => {
    const { initialState, setInitialState } = useModel('@@initialState');

    const changeStatus = (status: number) => {
        // console.log(111, status, initialState?.receiveStatus);
        //receiveStatus: 1:开启接单，2:关闭接单
        // if (initialState?.receiveStatus === status) {
        //     return;
        // }
        // 请求接口
        // 修改状态
        message.loading(intl.get('请求中'));
        changeReceiveStatus(initialState?.userInfo?.id || 0, status)
            .then(() => {
                message.success(intl.get('接单状态切换成功'));
                setInitialState({ ...initialState!, receiveStatus: status });
            })
            .catch(() => {
                message.error(intl.get('接单状态切换失败'));
            });
    };

    return (
        <>
            {initialState?.receiveStatus !== 1 ? (
                <span
                    onClick={(e) => {
                        e.preventDefault();
                        changeStatus(1);
                    }}
                    className={styles.headerBtn}
                >
                    {intl.get('开启接单')}
                </span>
            ) : (
                <span
                    onClick={(e) => {
                        e.preventDefault();
                        changeStatus(2);
                    }}
                    className={styles.headerBtn}
                >
                    {intl.get('关闭接单')}
                </span>
            )}
        </>
    );
};

export default ReceiveStatus;
